import { useRef } from 'react';
import { useParams } from 'react-router-dom';

import { IconButton, IconButtonSize } from '@xemplo/icon-button';
import { DawnAddPlus, DawnTag, IconGradient } from '@xemplo/icons';
import { useGetPayscheduleByIdQuery } from '@xemplo/pay-schedule-query';

import { EditTagsPrompt } from './edit-tags-prompt/edit-tags-prompt';
import { PromptDialogRef } from './edit-tags-prompt/edit-tags-prompt.types';
import * as S from './tags-card.styles';
import { TagsCardProps } from './tags-card.types';

export function TagsCard(props: TagsCardProps) {
  const { payscheduleId } = useParams<{ payscheduleId: string }>();
  const effectivePayscheduleId = props.payscheduleId ?? payscheduleId;
  const { data } = useGetPayscheduleByIdQuery({ id: effectivePayscheduleId });

  const displayTags = data?.result.tags?.length
    ? data.result.tags.join(', ')
    : 'No tags added yet';

  const tagPromptRef = useRef<PromptDialogRef>(null);

  if (!data?.result) {
    return null;
  }

  function openPrompt() {
    tagPromptRef.current?.openModalDialog();
  }
  return (
    <>
      <S.CardContainer className={props.className}>
        <S.Header>
          <S.IconWrapper>
            <DawnTag fontSize={24} />
            <IconGradient />
          </S.IconWrapper>
          <S.Title>Tags</S.Title>
          {!props.viewOnly && (
            <IconButton
              id="edit-tags-button"
              ariaLabel="Edit tags"
              size={IconButtonSize.Small}
              onClick={openPrompt}
            >
              <DawnAddPlus />
            </IconButton>
          )}
        </S.Header>

        <S.Tags>{displayTags}</S.Tags>
      </S.CardContainer>
      <EditTagsPrompt ref={tagPromptRef} payscheduleId={effectivePayscheduleId} />
    </>
  );
}
